<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <b-card :title="service_title" class="mr-1 ml-1">
      <b-row>
        <b-col>
            <p>
              <b>Ottieni più di 100 servizi e bonus pubblici online.</b> Con il provider BonusX scopri facilmente le agevolazioni e i servizi pubblici disponibili <b>per te e la tua famiglia.</b>
              Gestisci tutto online: dall'<b>Attestazione ISEE alle dichiarazioni fiscali, fino agli assegni familiari.</b> Crea il tuo profilo su BonusX e ottieni 
              ciò che ti spetta, in modo facile, veloce e professionale.
            </p>
            <p><b>Come funziona?</b></p>
            <p>
              <ul>
                <li>Una volta entrato rispondi ad un questionario inserendo le tue informazioni famigliari e patrimoniali: servono per verificare il possesso dei requisiti a bonus e agevolazioni integrate</li>
                <li>Vai nella sezione <i>Bonus</i>, <b>visualizza e richiedi i bonus a cui hai diritto</b></li>
                <li><b>Avvia una pratica online:</b> carica i documenti richiesti e il tutto viene gestito <b>un operatore esperto</b> che puoi contattare <b>via chat</b></li>
              </ul>
            </p>
            <p><b>Sei interessato a uno specifico bonus?</b></p>
            <p>Entra nella pagina dedicata al bonus e rispondi alle domande per capire se ne hai i requisiti!!!</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <!-- Per il form usiamo gli attributi "classici" e non effettuamo il submit con axios perchè ci serve il target "blank" per il redirect -->
          <!-- Il campo di input non lo prendiamo da bootstrap vue perchè hidden non è supportato -->
          <b-form target="_blank"
              ref="sso_form"
              method="POST"
              :action="login_url">
              <input type="hidden" name="data" :value="user_data">
              <input type="hidden" name="clientId" :value="client_id">
              <!-- Lavorando questo SSO in GET e non dovendo quindi effettuare la POST dei dati tramite form come per -->
              <!-- tantosvago, all'apertura del link l'evento di click apre la pagina di cortesia di redirect alla home -->
              <b-button v-if="show_access_button" @click="execute_sso()" variant="primary">Accedi al portale {{service_title}}</b-button>
          </b-form>
        </b-col>
      </b-row>
      <!-- Uno slot per del contenuto addizionale sotto al form -->
      <slot name="form-footer"></slot>
    </b-card>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'BonusXLogin',
  data () {
    return {

        // Variabili generali
        tagline_elem : [ { text : "Area Bonus Pubblici", link : 'conv-bonusx' } ],

        service_title : "Area Bonus Pubblici",

        // Un flag per visualizzare il pulsante di accesso, se e solo se
        // effettivameten quest'azienda può accedere a bonusx.
        show_access_button : false,

        // Dati per il form di login che sono valorizzati al create della pagina
        login_url: null,
        user_data : null,
        client_id : null
    }
  },
  /**
   * Alla creazione della pagina richiediamo i dati utente e popoliamo il form.
   */
  created : function () {

    axios.get( apiUrl.welfareapi.create_acq_bonusx_login )
    .then( ( response ) => {

      // Compilo tutti i dati necessari al form
      this.login_url = response.data.login_url;
      this.user_data = JSON.stringify(response.data.payload.data);
      this.client_id = response.data.client_id;

      // Tutto ok, l'azienda può suare bonusx, allora possiamo mostrare il pulsante di accesso
      // dopo aver settato tutto il necessario nel form.
      this.show_access_button = true;

    })
    .catch( ( error ) => {
      // Mostriamo il messaggio di errore e dopo l'ok riportiamo l'utente alla home.
      // dobbiamo tenerci da parte un riferimento al router che non è presente nello
      // scope della funzione di callback.
      const router_ref = this.$router;
      generalLib.backend_error_message_box( this, error.response.data,
        function() {
          router_ref.replace( { name : 'menu' });
        }
      );
    });

  },
  methods : {
    /**
     * Esegue l'SSO verso il portale Bonus-X eseguendo il submit del form
     * e mostra la pagina di cortesia.
     */
    execute_sso : function () {
      let form = this.$refs.sso_form;
      form.submit();
      this.$router.replace( { name : 'conv-redirect', params:  { page_title : this.service_title } });
    }
  },
  components: {
    PageTagline
  }
}
</script>

<style scoped>
</style>